import { render, staticRenderFns } from "./FormChangePlatform.vue?vue&type=template&id=4c154555&"
import script from "./FormChangePlatform.vue?vue&type=script&lang=js&"
export * from "./FormChangePlatform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports